<template>
    <Navbar></Navbar>
    <div class="page-box">
        <div class="img-box page-banner">
            <img data-src="/assets/manufacture/electronics/zhangjiagang/zjg.jpg" alt=""></img>
            <div class="title-box">
                <div class="manufacture-t1">
                    电子张家港工厂
                </div>
                <div class="manufacture-t2">
                    位于江苏省张家港市，占地面积2.2万㎡<br />
                    工厂具备SMT、DIP、组装测试等产线能力。
                </div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                PCBA - SMT
            </div>
        </div>

        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                高度自动化与智能化
                            </div>
                            <div class="destils">
                                -自动化生产：采用全自动贴片机、锡膏印刷机、回流焊炉等设备，减少人工干预，实现从PCB上料到成品下线的全程自动化<br />
                                -智能控制：通过MES（制造执行系统）和物联网（IoT）技术实时监控生产数据（如温度、速度、良率），动态优化工艺参数<br />
                                -AI与机器学习：部分高端产线引入AI进行缺陷检测（如AOI自动光学检测）、预测性维护（设备故障预警）和工艺优化
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/zhangjiagang/zjg1-1.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                高精度与高贴装速度
                            </div>
                            <div class="destils">
                                -贴装精度：先进贴片机（如西门子SX系列）可实现±25μm以下的精度，支持01005（0.4mm×0.2mm）甚至更小元件的贴装<br />
                                -高速贴装：多悬臂贴片机速度可达20万CPH（元件/小时）以上，双轨产线可并行生产，效率翻倍<br />
                                -微细间距能力：支持QFN、BGA、CSP等复杂封装，满足高密度PCB（如5G模块、汽车电子）需求
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/zhangjiagang/zjg1-2.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                柔性化与快速换线
                            </div>
                            <div class="destils">
                                -快速切换：通过智能编程和模块化设计，换线时间缩短至10分钟内（传统产线需30分钟以上），适应多品种、小批量生产<br />
                                -兼容性：同一产线可处理不同尺寸PCB（如50mm×50mm至510mm×460mm），支持LED、消费电子、医疗设备等多领域需求
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/zhangjiagang/zjg1-3.jpg" alt="">
                        </div>
                    </div>
                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                可靠性提升技术
                            </div>
                            <div class="destils">
                                -在线检测：集成AOI（自动光学检测）、AXI（X射线检测）和飞针测试，实时剔除不良品，直通率（FPY）达99%+<br />
                                -环境控制：恒温恒湿车间、防静电措施（ESD保护）确保精密元件安全。
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/zhangjiagang/zjg1-4.jpg" alt="">
                        </div>
                    </div>
                </div>
                <div class="kv_pagination swiper-pagination left"></div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                PCBA - DIP
            </div>
            
        </div>

        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/zhangjiagang/zjg2-1.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                焊产线
                            </div>
                            <div class="destils">
                                选择焊用于对通孔元件（THT）或混合技术（SMT+THT）PCB进行局部焊接，避免二次回流焊对敏感元件的热冲击<br />
                                -高精度焊接：采用多喷嘴选择性焊接，最小焊点间距可达2mm，适用于高密度PCB。激光或视觉定位（如Koh Young SPI）确保焊点位置精度±50μm以内<br />
                                -智能温控与氮气保护：独立温区控制（最高300℃），适应无铅（SnAgCu）或低温焊料（SnBi）。氮气惰性环境焊接，减少氧化，提高焊点可靠性（润湿性提升20%+）<br />
                                -柔性化生产：快速换线（＜5分钟），支持不同PCB尺寸（50mm×50mm至500mm×450mm）。可编程焊锡轨迹，适应异形元件（如连接器、大电容）<br />
                                -在线检测与追溯：集成AOI（自动光学检测）或3D焊点检测，实时反馈焊接质量。MES系统记录焊接参数（温度、速度、助焊剂用量），实现全流程追溯

                            </div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/zhangjiagang/zjg2-2.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                插针产线
                            </div>
                            <div class="destils">
                                插针工艺用于PCB通孔元件的自动化插装，如排针、端子、继电器等。<br />
                                -全自动高精度插装：采用伺服驱动+视觉对位，插装精度±0.05mm，支持0.5mm间距高密度排针。自动供料（振动盘/带式送料），插装速度10,000针/小时以上<br />
                                -智能防错与自适应调整：力反馈检测（防止插针弯曲或漏插），不良率＜0.1%。AI算法优化插装顺序，减少机械臂空跑时间<br />
                                -柔性化与快速换型：模块化夹具设计，换型时间＜3分钟，适应不同PCB和针型。支持通孔（THT）与压接（Press-fit）两种工艺
                            </div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/zhangjiagang/zjg2-3.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                Coating（涂覆）产线
                            </div>
                            <div class="destils">
                                涂覆工艺用于PCB三防漆（Conformal Coating）喷涂，提升防潮、防腐蚀、防尘能力。<br />
                                -高精度选择性喷涂：非接触式压电喷阀或超声波雾化喷涂，涂层厚度控制10-50μm（±5μm）。视觉定位（如Cognex系统）避开禁喷区（如连接器、测试点）<br />
                                -智能化工艺控制：自动调节喷涂压力、流量，适应不同粘度涂料（丙烯酸、硅胶、聚氨酯）。UV固化或热风固化，时间＜30秒，提升生产效率<br />
                                -环保与安全：封闭式喷涂+废气回收（VOC处理），符合RoHS/REACH标准。低损耗设计，涂料利用率>90%（传统喷涂仅60%）<br />
                                -在线检测与追溯：红外测厚仪或3D检测确保涂层均匀性。MES系统记录喷涂参数（时间、厚度、批次），支持质量回溯
                            </div>
                        </div>
                    </div>
                </div>
                <div class="kv_pagination swiper-pagination"></div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                高度自动化装配
            </div>
            <div class="page-t2">
                整机组装涉及结构件装配、螺丝锁附、胶合、线束连接、外壳封装等工序。
            </div>
        </div>

        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                机器人装配
                            </div>
                            <div class="destils">
                                采用协作机器人（Cobot）或六轴机械臂完成精密组装（如手机摄像头模组、电池安装）
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/zhangjiagang/zjg3-1.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                自动螺丝锁附
                            </div>
                            <div class="destils">
                                伺服电批+视觉定位，扭矩精度±1%，防漏锁、防浮锁（如DEPRAG智能螺丝机）
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/zhangjiagang/zjg3-2.jpg" alt="">
                        </div>
                    </div>

                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                自动点胶/贴合
                            </div>
                            <div class="destils">
                                高精度喷射点胶（误差±0.02mm），适用于屏幕贴合、防水密封（如武藏点胶系统）
                            </div>
                        </div>
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/zhangjiagang/zjg3-3.jpg" alt="">
                        </div>
                    </div>
                </div>
                <div class="kv_pagination swiper-pagination left"></div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                整机 - 测试
            </div>
            <div class="page-t2">
                测试环节涵盖全自动化测试、智能化数据分析、高兼容性测试系统、射频校准等。
            </div>
        </div>

        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/zhangjiagang/zjg4-1.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                全自动化测试
                            </div>
                            <div class="destils">
                                -机器人自动上下料：机械臂将待测产品送入测试工位，减少人工干预（如EPSON SCARA机器人）<br />
                                -并行测试：多工位同步测试（如4台手机同时进行5G射频校准），效率提升300%<br />
                                -AI视觉检测：深度学习算法识别外观缺陷（划痕、色差），准确率>99.9%（如Cognex ViDi）
                            </div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/zhangjiagang/zjg4-2.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                智能化数据分析
                            </div>
                            <div class="destils">
                                -实时监控与预警：SPC（统计过程控制）分析测试数据，自动触发报警（如某参数超差）<br />
                                -预测性维护：通过设备振动、温度数据预测测试仪器故障，减少停机时间
                            </div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="img-box">
                            <img data-src="/assets/manufacture/electronics/zhangjiagang/zjg4-3.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                高兼容性测试系统
                            </div>
                            <div class="destils">
                                -模块化测试架构：支持快速更换测试治具（如手机、TWS耳机、智能手表共用同一测试平台）<br />
                                -OTA（无线）测试：5G/Wi-Fi 6E/蓝牙自动化射频测试（如Keysight UXM5G测试仪）
                            </div>
                        </div>
                    </div>
                </div>
                <div class="kv_pagination swiper-pagination"></div>
            </div>
        </div>


    </div>
    <Footer></Footer>
</template>

<script setup>
import { ref, onMounted, onUnmounted, nextTick } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
import $ from 'jquery';

// 存储所有swiper实例，方便销毁
const swiperInstances = ref([]);

// 初始化所有轮播的核心函数
const initAllSwipers = async () => {
    await nextTick();

    const swiperElements = document.querySelectorAll('.swiper-item');

    swiperElements.forEach(el => {
        if (el) {
            const swiper = new Swiper(el, {
                speed: 1300,
                pagination: {
                    el: el.querySelector(".swiper-pagination"), // 绑定当前容器内的分页器
                    clickable: true,
                },
                direction: "horizontal",
                slidesPerView: 1,
                // spaceBetween: 20,
                simulateTouch: true,
                effect: 'fade',
                breakpoints: {
                    768: {},
                    1024: {}
                },
                // navigation: {
                //     nextEl: el.querySelector(".btn-r"),
                //     prevEl: el.querySelector(".btn-l"),
                //     disabledClass: 'swiper-button-disabled',
                // },
                on: {
                    // init: function () {
                    //     console.log('轮播初始化完成');
                    // },
                    // slideChangeTransitionStart(swiper) {
                    //     let swiperIndex = swiper.realIndex;
                    //     console.log('当前轮播索引：', swiperIndex);
                    // },
                },
            });
            swiperInstances.value.push(swiper); // 保存实例
        }
    });
};

// 页面挂载时初始化轮播
onMounted(() => {
    initAllSwipers();
});

// 页面卸载时销毁轮播实例（防止内存泄漏）
onUnmounted(() => {
    swiperInstances.value.forEach(swiper => {
        swiper.destroy(true, true);
    });
    swiperInstances.value = [];
});
</script>

<script>
export const pageConfig = {
    title: '电子张家港工厂 - 蜂巢汽车官网',
    keywords: '蜂巢,蜂巢汽车,发动机,变速器,电子',
    description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
    outputPath: 'manufacture/el/zhangjiagang.html'
};

import { createApp } from 'vue';
import App from './zhangjiagang.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/manufacture-detail.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./zhangjiagang.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss"></style>
